import React from 'react'
import { render } from 'react-dom'
import { ConfigProvider } from 'antd'
import { Global, css } from '@emotion/core'
import zhCN from 'antd/lib/locale-provider/zh_CN'
import CloudGameRoot from 'src/pc/CloudGame/CloudGameRoot'
import DinFont from '../assets/font/din-bold.20720c3a.otf'

render(
  <ConfigProvider locale={zhCN}>
    <Global
      styles={css`
        html {
          font-size: 100px;
        }
        @font-face {
          font-family: 'Din';
          src: url(${DinFont});
        }
        @media screen and (max-width: 1000px) {
          html {
            font-size: 80px;
          }
        }
      `}
    />
    <CloudGameRoot />
  </ConfigProvider>,
  document.getElementById('root'),
)
